/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S5_Supabase_DescInputs */

const tr_cerez_s5_supabase_desc = /** @type {(inputs: Cerez_S5_Supabase_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oturum yönetimi (zorunlu)`)
};

const en_cerez_s5_supabase_desc = /** @type {(inputs: Cerez_S5_Supabase_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`session management (necessary)`)
};

const de_cerez_s5_supabase_desc = /** @type {(inputs: Cerez_S5_Supabase_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzungsverwaltung (erforderlich)`)
};

const ru_cerez_s5_supabase_desc = /** @type {(inputs: Cerez_S5_Supabase_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`управление сессией (обязательно)`)
};

/**
* | output |
* | --- |
* | "session management (necessary)" |
*
* @param {Cerez_S5_Supabase_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s5_supabase_desc = /** @type {((inputs?: Cerez_S5_Supabase_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S5_Supabase_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s5_supabase_desc(inputs)
	if (locale === "de") return de_cerez_s5_supabase_desc(inputs)
	if (locale === "ru") return ru_cerez_s5_supabase_desc(inputs)
	return tr_cerez_s5_supabase_desc(inputs)
});